import Login from "./Components/Login";
import {  Routes, Route, Navigate, useNavigate } from "react-router-dom";
import { store } from "./redux/store";
import { Provider } from "react-redux";
import OnBoarding from "./Components/OnBoarding";
import Signup from "./Components/Signup";
import PrivateRoute from "./Components/PrivateRoute";
import RestrictedRoute from "./Components/RestrictedRoute";
import Dashboard from "./Components/Dashboard/Dashboard";
import Bookings from "./Components/Dashboard/Bookings";
import Rooms from "./Components/Dashboard/Rooms";
import Request from "./Components/Dashboard/Request";
import Analytics from "./Components/Dashboard/Analytics";

// React Query imports
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import ManageGuest from "./Components/Dashboard/ManageGuest";
import ManageRoom from "./Components/Dashboard/ManageRoom";

// Staff Task 
import StaffTask from "./Components/StaffTask/StaffTask";

// For Alrets
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useEffect, useState } from "react";
import axiosInstance from "./api/axiosInstance";
import PageLoader from "./Components/loader/PageLoader";
import Promotions from "./Components/Dashboard/Promotions/Promotions";
import useVersionCheck from "./hooks/useVersionCheck";
import useSessionGuard from "./hooks/useSessionGuard";
import { hasValidSession, getHotelId } from "./auth/session";

// Create a QueryClient instance
const queryClient = new QueryClient();

function App() {


    const navigate = useNavigate();
    const [isLoading,setIsLoading] = useState(false);

    useVersionCheck();
    useSessionGuard();

    // User Authentication
    useEffect(()=>{
        const checkToken = async()=>{
            try{
                setIsLoading(true);
                const currentPath = window.location.pathname;  
                const unprotectedPaths = ["/staffTask"]; // Define routes that should bypass the token check
        
                if (unprotectedPaths.includes(currentPath)) {
                    return; // Skip token check for unprotected paths
                }

                // useSessionGuard already redirects an invalid session; this only
                // decides where a valid one lands.
                if(hasValidSession()){
                    const hotelId = getHotelId();
                    if(hotelId){
                        try{
                            const response = await axiosInstance.get(`/api/v1/hotels/${hotelId}`);
                            const hotelData = response.data;
                            // console.log("Check it out",hotelData)
                            if(!hotelData){
                                navigate("/onboard")
                            }else{

                                if(hotelData.address && hotelData.postal_code && hotelData.contact && hotelData.name!==""){
                                    navigate("/dashboard/request")
                                }
                                else{
                                    navigate("/onboard")
                                }
                            }
                        }catch(error){
                            console.log(error)    
                            navigate("/onboard");
                            
                        }
                    }
                }
            }catch(error){
                console.log(error);
                setIsLoading(false);
            }
            finally{
                // console.log("End");
                setIsLoading(false);
            }
        }
        checkToken();
    },[]);

    if(isLoading){
        return <div className="w-full min-h-screen flex justify-center m-auto items-center">
            <PageLoader/>            
        </div>
    }

    return (
        <Provider store={store}>
            <ToastContainer />
            <QueryClientProvider client={queryClient}>
                {/* <BrowserRouter> */}
                    <Routes>
                        <Route path="/" element={<Login />} />
                        <Route path="/signup" element={<Signup />} />

                        {/* Staff Task */}
                        <Route path="/staffTask" element={<StaffTask />} />

                        <Route element={<PrivateRoute />}>
                            <Route path="/onboard" element={<OnBoarding />} />
                        </Route>
                        <Route
                            path="/dashboard"
                            element={<Navigate to="/dashboard/request" />}
                        />
                        <Route path="/dashboard/*" element={<Dashboard />}>

                            <Route element={<RestrictedRoute title="Promotions" />}>
                                <Route path="promotions" element={<Promotions />} />
                            </Route>
                            <Route path="request" element={<Request />} />
                            <Route path="bookings" element={<Bookings />}>
                                {/* <Route
                                    path="manage-guest/:id/:roomId"
                                    element={<ManageGuest />}
                                />
                                <Route
                                    path="manage-room/:id/:roomId"
                                    element={<ManageRoom />}
                                /> */}
                            </Route>

                            {/* Rooms route with nested manage-guest modal */}
                            <Route path="rooms" element={<Rooms />}>
                                <Route
                                    path="manage-guest/:id/:roomId"
                                    element={<ManageGuest />}
                                />
                                <Route
                                    path="manage-room/:id/:roomId"
                                    element={<ManageRoom />}
                                />
                            </Route>
                            <Route element={<RestrictedRoute title="Analytics" />}>
                                <Route path="analytics" element={<Analytics />} />
                            </Route>
                        </Route>
                    </Routes>
                    <ReactQueryDevtools initialIsOpen={false} />
                {/* </BrowserRouter> */}
            </QueryClientProvider>
        </Provider>
    );
}

export default App;
